import React, { useState } from 'react';
import styles from './MercenaryTabs.module.css';
import ProfileView from './ProfileView';
import BattleHistory from './BattleHistory';
import Inventory from './Inventory';
import DailyMissions from '../DailyMissions/DailyMissions';
import MercenaryAdvancements from './MercenaryAdvancements';
import Finances from './Finances';

const MercenaryProfile: React.FC = () => {
    const [activeTab, setActiveTab] = useState<'Profile' | 'Inventory' | 'Missions' | 'Battle History' | 'Advancements' | 'Finance'>('Profile');

    return (
        <div className={styles.container}>
            <div className={styles.headerSection}>
                <h1 className={styles.title}>Mercenary Management</h1>
                <p className={styles.subtitle}>Manage your champion's progress and equipment</p>
            </div>

            <div className={styles.tabNav}>
                <button 
                    className={`${styles.tabButton} ${activeTab === 'Profile' ? styles.activeTab : ''}`}
                    onClick={() => setActiveTab('Profile')}
                >
                    Profile
                </button>
                <button 
                     className={`${styles.tabButton} ${activeTab === 'Inventory' ? styles.activeTab : ''}`}
                     onClick={() => setActiveTab('Inventory')}
                >
                    Inventory
                </button>
                <button 
                     className={`${styles.tabButton} ${activeTab === 'Missions' ? styles.activeTab : ''}`}
                     onClick={() => setActiveTab('Missions')}
                >
                    Missions
                </button>
                <button 
                     className={`${styles.tabButton} ${activeTab === 'Battle History' ? styles.activeTab : ''}`}
                     onClick={() => setActiveTab('Battle History')}
                >
                    Battle History
                </button>
                <button 
                     className={`${styles.tabButton} ${activeTab === 'Advancements' ? styles.activeTab : ''}`}
                     onClick={() => setActiveTab('Advancements')}
                >
                    Advancements
                </button>
                <button 
                     className={`${styles.tabButton} ${activeTab === 'Finance' ? styles.activeTab : ''}`}
                     onClick={() => setActiveTab('Finance')}
                >
                    Finance
                </button>
            </div>

            <div className={styles.tabContent}>
                {activeTab === 'Profile' && <ProfileView />}
                {activeTab === 'Inventory' && <Inventory />}
                {activeTab === 'Missions' && <DailyMissions />}
                {activeTab === 'Battle History' && <BattleHistory />}
                {activeTab === 'Advancements' && <MercenaryAdvancements />}
                {activeTab === 'Finance' && <Finances />}
            </div>
        </div>
    );
};

export default MercenaryProfile;
